export const HEADER_ELEMENT_ID = 'header';
